var params = {'4':[
  ['0','R','P','E','B'],  // 0 - product R
  ['0','AM','AQ','CT','LBT','RH','PT','PZ','TZ','WT'],  // 1 - center stone color
  ['0','AM','AQ','CT','LBT','RH','PT','PZ','TZ','WT'],  // 2 - center stone color 2
  ['HRD','HOV','HPS','HCU','HECU'],  // 3 - center stone shape
  ['1','2','3'],  // 4 - center stone size
  ['0','AM','AQ','CT','EM','GA','LBT','MG','PT','PZ','RU','SAP','TZ','WT','D'],  // 5 - head stones color
  ['0','AM','AQ','CT','EM','GA','LBT','MG','PT','PZ','RU','SAP','TZ','WT','D'],  // 6 - shank stones color
  ['0','S','10W','10Y','10R','14W','14Y','14R'],  // 7 - metal 1
  ['0','S','10W','10Y','10R','14W','14Y','14R'],  // 8 - metal 2
  ['0','4','4.5','5','5.5','6','6.5','7','7.5','8','8.5','9'],  // 9 - ring size
  ['0','6','7','8'], // 10 - brac length
  ['J','K','Z','1','2','3','4','5'],  // 11 - store
  ['R1','R2','R3','R4','R5','R6','R7','R8','R9','R10','R11','R12','R13','R14','R15','P1','P2','P3','P4','P5','P6','P7','P8','P9','P10','E1','E2','E3','E4','E5','E6','E7','E8','E9','E10','B1','B2','B3','B4','B5','B6','B7','B8','B9','B10'],  // 12 - style
]}
 //['SBT','AM','AQ','CT','LBT','RH','PT','PZ','TZ','WT'],  // 1 - center stone color
 // ['SBT','AM','AQ','CT','LBT','RH','PT','PZ','TZ','WT'],  // 2 - center stone color 2
// PARAMS
// s - size (thumb,500,2000) default 500
// v - view (0,1,2,3) default = 0
// e - engraving (for r,b1,b2) for add to cart
// u - user diamond for add to cart(6 params)

var TOTAL_PARAM = Object.keys(params['4']).length
var ring_list = Array.from(Array(TOTAL_PARAM).keys())
 
var ring_val = [];
var ring_val2 = [];
var version = '4';
var p = params[version];
var base = 35;

var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';

function init() {
  var i;
  for (i in ring_list) {
    ring_val.push(p[ring_list[i]].length);
  }
  var n = 1;
  for (i = 0; i < ring_val.length; i++) {
    n = n * ring_val[i];
    ring_val2.push(n);
  }
}

export function param2sku(in1) {
  var in2 = in1;
  var in3 = [];
  var in_ring = [];
  var i;
  var error = '';
  var res;
  if (in2.length < TOTAL_PARAM)
    error += 'param count in less than ' + String(TOTAL_PARAM);
  for (i = 0; i < TOTAL_PARAM; i++) {
    res = p[i].indexOf(in2[i]);
    if (res !== -1)
      in3.push(res);
    else {
      in3.push(0);
      error += 'error: ' + String(in2[i]) + ' not in index array ' + String(i) + ';';
    }
  }
  for (i = 0; i < ring_list.length; i++)
    in_ring.push(in3[ring_list[i]]);
  var sku = version + param2skupart(in_ring, ring_val, ring_val2, base)
  return [sku, error];
}

function param2skupart(in1, max_val, max_val2, base) {
  var sku = '';
  var dec = 0;
 var mul;
 var i;
  for (i = 0; i < max_val.length; i++) {
    if (i === 0)
      mul = 1;
    else
      mul = max_val2[i - 1];
    dec += in1[i] * mul;
  }
  var sk = DecimalToBase(dec, base);
  sku = '';
  for (i = 0; i < sk.length; i++)
    sku = alphabet[sk[i]] + sku;
  return sku;
}

 function sku2param(in1) {
  var resarray = new Array(TOTAL_PARAM).fill(0);
  var in2 = in1.substring(1);
  var in3 = in2.split('0');
  var ring = sku2parampart(in3[0], ring_val2);
  var i;
  for (i = 0; i < ring.length; i++)
    resarray[ring_list[i]] = ring[i];  
  var res = [];
  for (i = 0; i < resarray.length; i++) {
    res.push(p[i][resarray[i]]);
  }
  return res;
}

function sku2parampart(in2, max_temp) {
  var in1 = [];
  var pos;
  var i;
  for (i = 0; i < in2.length; i++) {
    pos = alphabet.indexOf(in2[i]);
    in1.push(pos);
  }
  var dec = 0;
  var param = [];
  for (i = 0; i < in1.length; i++)
    dec += in1[i] * Math.pow(base, in1.length - i - 1);
  var maxlen = max_temp.length;
  for (i = 0; i < maxlen; i++) {
    if (i === maxlen - 1)
      param.unshift(Math.floor(dec));
    else
      param.unshift(Math.floor(dec / max_temp[maxlen - i - 2]));
    dec = Number(dec % max_temp[maxlen - i - 2]);
  }
  return param;
}

function __DecimalToBaseRecur__(array, decimal, base) {
  array.push(decimal % base);
  var div = Math.floor(decimal / base);
  if (div === 0)
    return;
  __DecimalToBaseRecur__(array, div, base);
}

function DecimalToBase(decimal, base) {
  var array = [];
  __DecimalToBaseRecur__(array, decimal, base);
  return array;
}

init();

export function sku4ring (sku) {
  let res = sku2param(sku)
  let res2 = param2sku(res)[0]
  return res2
}

export function sku2array(in1) {
  let res = sku2param(in1)
  let res2 = {}
  res2['type'] = res[0]
  res2['cec'] = res[1]
  res2['cec2'] = res[2]
  res2['ds'] = res[3]
  res2['dctw'] = res[4]
  res2['headc'] = res[5]
  res2['rsetc'] = res[6]
  res2['hmet'] = res[7]
  res2['rmet'] = res[8]
  res2['rs'] = res[9]
  res2['bl'] = res[10]
  res2['store'] = res[11]
  res2['sh'] = res[12]

  if (window.currentSite === 'kay') {
    res2['store'] = 'K'
  }
  if (window.currentSite === 'kay' && res[11] !== 'K') {
    res[11] = 'K'
    res2['sku'] = param2sku(res)[0]
  }
  if (window.currentSite === 'kayoutlet') {
    res2['store'] = '1'
  }
  if (window.currentSite === 'kayoutlet' && res[11] !== '1') {
    res[11] = '1'
    res2['sku'] = param2sku(res)[0]
  }
  if (window.currentSite === 'jared') {
    res2['store'] = 'J'
  }
  if (window.currentSite === 'jared' && res[11] !== 'J') {
    res[11] = 'J'
    res2['sku'] = param2sku(res)[0]
  }
  if (window.currentSite === 'zales') {
    res2['store'] = 'Z'
  }
  if (window.currentSite === 'zales' && res[11] !== 'Z') {
    res[11] = 'Z'
    res2['sku'] = param2sku(res)[0]
  }
  return res2   
} 


// WEBPACK FOOTER //
// ./src/logic/sku-ver3.js